
  <h4 class="card-header">Guardian Direct Registration</h4>

      <div class="alert alert-danger text-center" *ngIf="responseMessage!=''">
          {{responseMessage}}
      </div>

      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="form-group row" [ngClass]="{error:f.username.errors && f.username.touched}">
          <label for="username" class='control-label col-sm-3' >Email</label>
              <div class="input-group controls col-sm-8">
                <input placeHolder="Email" type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': f.username.errors && f.username.touched }" />
              </div>
              <div *ngIf="f.username.errors && f.username.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                <ul>
                    <li>Email Required.</li>
                </ul>
            </div>
        </div>

        <div class="form-group row" [ngClass]="{error:f.password.errors && f.password.touched}">
          <label for="password" class='control-label col-sm-3' >Password</label>
              <div class="input-group controls col-sm-8">
                <input placeHolder="Password" type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': f.password.errors && f.password.touched }" />
              </div>
              <div *ngIf="f.password.errors && f.password.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                <ul>
                    <li>Password Required.</li>
                </ul>
            </div>
        </div>

        <div class="form-group row" [ngClass]="{error:f.passwordConfirmation.errors && f.passwordConfirmation.touched}">
          <label for="passwordConfirmation" class='control-label col-sm-3' >Password</label>
              <div class="input-group controls col-sm-8">
                <input placeHolder="Password Confirmation" type="password" formControlName="passwordConfirmation" class="form-control" [ngClass]="{ 'is-invalid': f.passwordConfirmation.errors && f.passwordConfirmation.touched }" />
              </div>
              <div *ngIf="f.passwordConfirmation.errors && f.passwordConfirmation.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                <ul>
                    <li>Password Confirmation Required.</li>
                </ul>
            </div>
        </div>
        <div class="form-group row" [ngClass]="{error:f.reason.errors && f.reason.touched}">
          <label for="reason" class='control-label col-sm-3' >Reason</label>
              <div class="input-group controls col-sm-8">
                <select class="form-control"    formControlName="reason">
                  <option *ngFor="let vv of reasons" [value]="vv.id">{{vv.name}}</option>
                </select>
              </div>
              <div *ngIf="f.reason.errors && f.reason.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                <ul>
                    <li>Reason Required.</li>
                </ul>
            </div>
        </div>



          <div class="form-group row input-group-lg mt-5">
              <div class="col-sm-6 offset-sm-3">
              <button [disabled]="loading" class="btn btn-primary btn-lg btn-block">
                  <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                  Submit
              </button>
          </div>
          </div>
      </form>



